















































import { Component,Vue,Prop } from 'vue-property-decorator'
@Component({})
export default class MdcCard extends Vue{
  @Prop({type:Boolean,default:false}) outlined!:boolean
  @Prop({default:undefined}) tabindex?:number
  @Prop({type:Boolean,default:false}) mediaSquare!:boolean
  @Prop({type:Boolean,default:false}) media16_9!:boolean
  @Prop({type:Boolean,default:false}) mediaContent!:boolean
  @Prop({type:Boolean,default:false}) primaryRipple!:boolean
  @Prop({default:undefined}) mediaSrc?:string
  @Prop({type:Boolean,default:true}) themeTextSecondary!:boolean
  hasSlot_(name:string):boolean{
    return this.$slots[name] !== undefined
  }
  get hasPrimaryAction_(){
    return this.hasSlot_('title') || 
      this.hasSlot_('subtitle') || 
      this.hasSlot_('body') ||
      this.mediaSrc !== undefined
  }
  get isPrimaryBody_(){
    return !(this.hasSlot_('title') || this.hasSlot_('subtitle'))
  }
  
}
